<template>
  <div id="UiHeader">
    <el-menu router :default-active="activeIndex" menu-trigger="click" background-color="#001529" text-color="#fff"
      active-text-color="#1890ff" mode="horizontal">
      <el-menu-item v-if="isAuthoritiy('平台概览')" index="/console">平台概览</el-menu-item>
      <el-menu-item v-if="isAuthoritiy('分屏监控')" index="/live">分屏监控</el-menu-item>
      <!--      <el-menu-item index="/map">电子地图</el-menu-item>-->
      <el-menu-item v-if="isAuthoritiy('设备列表')" index="/deviceList">设备列表</el-menu-item>
      <el-menu-item v-if="isAuthoritiy('推流列表')" index="/streamPushList">推流列表</el-menu-item>
      <!-- <el-menu-item v-if="isAuthoritiy('拉流代理')" index="/streamProxyList">拉流代理</el-menu-item> -->
      <el-menu-item v-if="isAuthoritiy('报警列表')" index="/alarmList">报警列表</el-menu-item>
      <el-submenu v-if="isAuthoritiy('区域管理')" index="/channel">
        <template slot="title">区域管理</template>
        <el-menu-item index="/channel/region">行政区划</el-menu-item>
        <el-menu-item index="/channel/group">业务分组</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item v-if="isAuthoritiy('录制计划')" index="/recordPlan">录制计划</el-menu-item> -->
      <!-- <el-menu-item v-if="isAuthoritiy('云端录像')" index="/cloudRecord">云端录像</el-menu-item> -->
      <!-- <el-menu-item v-if="isAuthoritiy('节点管理')" index="/mediaServerManger">节点管理</el-menu-item> -->
      <!-- <el-menu-item v-if="isAuthoritiy('国标级联')" index="/platformList/15/1">国标级联</el-menu-item> -->
      <el-menu-item v-if="isAuthoritiy('用户管理')" index="/userManager">用户管理</el-menu-item>
      <el-menu-item v-if="isAuthoritiy('报修管理')" index="/repairRequestManager">报修管理</el-menu-item>
      <!-- <el-menu-item v-if="isAuthoritiy('运维中心')" index="/operations">运维中心</el-menu-item> -->
      <el-submenu v-if="isAuthoritiy('系统设置')" index="/setting">
        <template slot="title">系统设置</template>
        <!-- <el-menu-item index="/setting/web">WEB服务</el-menu-item> -->
        <el-menu-item index="/setting/sip">国标服务设置</el-menu-item>
        <!-- <el-menu-item index="/setting/media">媒体服务</el-menu-item> -->
      </el-submenu>
      <el-menu-item style="float: right;" @click="loginout">退出</el-menu-item>
      <el-submenu index="" style="float: right;">
        <template slot="title">欢迎，{{ username }}</template>
        <!-- <el-menu-item @click="openDoc">在线文档</el-menu-item> -->
        <el-menu-item>
          <el-switch v-model="alarmNotify" inactive-text="报警信息推送" @change="alarmNotifyChannge"></el-switch>
        </el-menu-item>
        <el-menu-item @click="changePassword">修改密码</el-menu-item>
        <el-menu-item @click="loginout">注销</el-menu-item>
      </el-submenu>
    </el-menu>
    <changePasswordDialog ref="changePasswordDialog"></changePasswordDialog>
    <devicePlayer ref="devicePlayer"></devicePlayer>
  </div>
</template>

<script>
import changePasswordDialog from '../components/dialog/changePassword.vue'
import devicePlayer from '../components/dialog/devicePlayer.vue'
import userService from '../components/service/UserService'
import { Notification } from 'element-ui';
import AlarmNotification from '../components/alarm/AlarmNotification.vue';

export default {
  name: "UiHeader",
  components: { Notification, changePasswordDialog, devicePlayer, AlarmNotification },
  data() {
    return {
      alarmNotify: false,
      sseSource: null,
      username: '',
      role: {},
      userAuthorities: [], // 存储用户权限
      activeIndex: this.$route.path.indexOf("/", 1) > 0 ? this.$route.path.substring(0, this.$route.path.indexOf("/", 1)) : this.$route.path,
      // editUser: userService.getUser() ? userService.getUser().role.id === 1 : false
      videoLoading: false, // 视频加载状态
      alarmAudio: null, // 报警提示音
      activeAlarmDevices: new Set(), // 跟踪已弹出报警窗口的设备ID
      deviceLastAlarmTime: new Map(), // 跟踪每个设备最后一次报警时间
    };
  },
  created() {
    // console.log(this.$route.path)
    // console.log(this.$route.path.indexOf("/", 1))
    // console.log(this.activeIndex)
    if (this.$route.path.startsWith("/channelList")) {
      this.activeIndex = "/deviceList"
    }
    setTimeout(() => {
      if (this.$route.path.indexOf("/console") === 0 && !this.isAuthoritiy('平台概览')) {
        this.$router.replace('/live');
      }
    }, 10);
  },
  mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
    this.getUserInfo();
    this.alarmNotify = this.getAlarmSwitchStatus() === "true";

    // 初始化报警提示音
    this.alarmAudio = new Audio();
    this.alarmAudio.src = '/static/audio/police.mp3';
    this.alarmAudio.load();

    // TODO: 此处延迟连接 sse, 避免 sse 连接时 browserId 还未生成, 后续待优化
    setTimeout(() => {
      this.sseControl()
    }, 3000);
  },
  methods: {
    loginout() {
      this.$axios({
        method: 'get',
        url: "/api/user/logout"
      }).then((res) => {
        // 删除用户信息，回到登录页面
        userService.clearUserInfo()
        this.$router.push('/login');
        if (this.sseSource != null) {
          this.sseSource.close();
        }

      }).catch((error) => {
        console.error("登出失败")
        console.error(error)
      });
    },
    getUserInfo() {
      // 获取用户信息和权限
      this.$axios({
        method: "GET",
        url: "/api/user/userInfo",
      }).then((res) => {
        if (res.data.code === 0) {
          this.username = res.data.data.username;
          // 获取用户角色的权限
          if (res.data.data.role && res.data.data.role.authority) {
            this.role = res.data.data.role;
            this.userAuthorities = res.data.data.role.authority.split(',');
          }
        }
      });
    },
    isAuthoritiy(authority) {
      if (this.role.id === 1) {
        return true;
      }
      return this.userAuthorities.indexOf(authority) > -1;
    },
    changePassword() {
      this.$refs.changePasswordDialog.openDialog()
    },
    openDoc() {
      console.log(process.env.BASE_API)
      window.open(!!process.env.BASE_API ? process.env.BASE_API + "/doc.html" : "/doc.html")
    },
    beforeunloadHandler() {
      this.sseSource.close();
    },
    alarmNotifyChannge() {
      this.setAlarmSwitchStatus()
      // 当报警通知开关状态改变时，只需要控制SSE连接
      // 后端已经实现了通过SSE推送报警信息的功能
      // 不需要额外的API调用，只需要通过SSE连接接收报警信息
      console.log("报警通知状态已更改为: " + (this.alarmNotify ? "开启" : "关闭"))
      this.sseControl()
    },
    sseControl() {
      let that = this;
      if (this.alarmNotify) {
        console.log("申请SSE推送API调用，浏览器ID: " + this.$browserId);
        // 获取登录token
        const token = userService.getToken();

        // 构建URL，添加browserId和access-token参数
        let url = (process.env.NODE_ENV === 'development' ? "http://localhost:18080/api/emit?browserId=" : "") + 'api/emit?browserId=' + this.$browserId;
        if (token) {
          url += '&access-token=' + token;
        }

        // 创建EventSource实例
        this.sseSource = new EventSource(url);
        this.sseSource.addEventListener('open', function (e) {
          console.log("SSE连接已打开，开始接收服务器信息", e);
          that.$message({
            message: '报警信息订阅已开启',
            type: 'success',
            duration: 2000
          });
        }, false);
        this.sseSource.addEventListener('error', function (e) {
          if (e.target.readyState == EventSource.CLOSED) {
            console.log("SSE连接关闭");
          } else {
            console.log("SSE连接错误：", e.target.readyState);
            that.$message({
              message: '报警信息订阅连接异常，请稍后重试',
              type: 'error',
              duration: 3000
            });
          }
        }, false);
        this.sseSource.addEventListener('message', function (evt) {
          console.log("收到服务器信息：", evt.data);
          let data = JSON.parse(evt.data);
          console.log(`that.videoLoading: ${that.videoLoading}`);

          // 获取设备ID，支持多种可能的字段名
          const deviceId = data.deviceId || data.deviceCode || data.id || data.channelId;

          // 检查该设备是否已有活跃的报警窗口
          if (deviceId && that.activeAlarmDevices.has(deviceId)) {
            console.log(`设备 ${deviceId} 已有活跃的报警窗口，跳过重复弹窗`);
            return;
          }

          // 检查该设备是否在15秒内已经弹出过报警窗口
          const currentTime = Date.now();
          const lastAlarmTime = that.deviceLastAlarmTime.get(deviceId);
          if (deviceId && lastAlarmTime && (currentTime - lastAlarmTime) < 15000) {
            console.log(`设备 ${deviceId} 在15秒内已弹出过报警窗口，跳过重复弹窗`);
            return;
          }

          // 更新设备最后报警时间
          if (deviceId) {
            that.deviceLastAlarmTime.set(deviceId, currentTime);
          }

          // 将设备ID添加到活跃报警设备集合中
          if (deviceId) {
            that.activeAlarmDevices.add(deviceId);
          }

          // 增强报警信息展示
          // 使用Vue组件方式创建通知
          const h = that.$createElement;
          const notification = that.$notify({
            title: '设备报警通知',
            message: h(AlarmNotification, {
              props: {
                alarmData: data,
                loading: that.videoLoading
              },
              on: {
                'update:loading': (val) => {
                  that.videoLoading = val;
                }
              }
            }),
            type: 'warning',
            position: 'bottom-right',
            duration: 30000,
            showClose: true,
            onClose: function () {
              // 当报警窗口关闭时，从活跃设备集合中移除该设备ID
              if (deviceId) {
                that.activeAlarmDevices.delete(deviceId);
                console.log(`设备 ${deviceId} 的报警窗口已关闭，从活跃列表中移除`);
              }
            }
          });

          // 播放报警提示音
          if (that.alarmAudio) {
            that.alarmAudio.currentTime = 0; // 重置播放位置
            that.alarmAudio.play().catch(err => {
              console.error('播放报警提示音失败:', err);
            });
          }
        });
        this.sseSource.addEventListener('keepalive', function (e) {
          console.log("SSE消息：keepalive", e);
        }, false);
      } else {
        if (this.sseSource != null) {
          this.sseSource.removeEventListener('open', null);
          this.sseSource.removeEventListener('message', null);
          this.sseSource.removeEventListener('error', null);
          this.sseSource.close();
          this.$message({
            message: '报警信息订阅已关闭',
            type: 'info',
            duration: 2000
          });
        }
      }
    },
    getAlarmSwitchStatus() {
      if (localStorage.getItem("alarmSwitchStatus") == null) {
        localStorage.setItem("alarmSwitchStatus", false);
      }
      return localStorage.getItem("alarmSwitchStatus");
    },
    setAlarmSwitchStatus() {
      localStorage.setItem("alarmSwitchStatus", this.alarmNotify);
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    if (this.sseSource != null) {
      this.sseSource.removeEventListener('open', null);
      this.sseSource.removeEventListener('message', null);
      this.sseSource.removeEventListener('error', null);
      this.sseSource.close();
    }
  },
}

</script>
<style>
#UiHeader .el-switch__label {
  color: white;
}

.el-menu--popup .el-menu-item .el-switch .el-switch__label {
  color: white !important;
}

#UiHeader .el-switch__label.is-active {
  color: #409EFF;
}

#UiHeader .el-menu-item.is-active {
  color: #fff !important;
  background-color: #1890ff !important;
}

#UiHeader .el-submenu.is-active {
  background-color: #1890ff !important;
}

#UiHeader .el-submenu.is-active .el-submenu__title {
  color: #fff !important;
  background-color: #1890ff !important;
}

#UiHeader .el-submenu.is-active .el-submenu__icon-arrow {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/UiHeader.vue